<template>
    <div>Niente da vedere, vai oltre</div>
</template>

<script>
</script>